import { render, staticRenderFns } from "./SearchFilterBtn.vue?vue&type=template&id=25c661d7"
import script from "./SearchFilterBtn.vue?vue&type=script&lang=ts"
export * from "./SearchFilterBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports